import { useState } from 'react';
import { Alert, Box, Button, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import {
  WizardStepRoot,
  WizardStepActions,
  WizardStepContent,
  WizardStepProps,
} from 'components/WizardModal';
import { URLS } from 'consts';
import { useIsMdBreakpoint } from 'hooks';
import { ArrowRightIcon } from 'icons';

import { SelectTemplate } from './components/SelectTemplate';

type StepContext = {
  templateId?: string;
};

export const StepSelectTemplate: React.FC<WizardStepProps<StepContext>> = ({
  close,
  context,
  stepDone,
  goToNextStep,
}) => {
  const isMdBreakpoint = useIsMdBreakpoint();
  const { t } = useTranslation();
  const [templateId, setTemplateId] = useState<string | undefined>(
    context.templateId,
  );

  const onNext = () => {
    if (templateId) {
      stepDone();
      goToNextStep({ templateId });
    }
  };

  return (
    <WizardStepRoot>
      <WizardStepContent>
        <Box
          sx={{
            overflow: 'hidden',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        >
          <Alert color="blue" mih="fit-content">
            <Trans
              i18nKey="forms:newFormWizard.selectTemplateInfo"
              components={[
                <Text
                  component={Link}
                  span
                  c="violet.0"
                  inherit
                  to={URLS.templateAdd}
                />,
              ]}
            />
          </Alert>

          <SelectTemplate
            px={16}
            mx={-16}
            value={templateId}
            onChange={(event, id) => setTemplateId(id)}
          />
        </Box>
      </WizardStepContent>
      <WizardStepActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            gap: 8,
            flexDirection: isMdBreakpoint ? 'row-reverse' : 'column',
            justifyContent: 'flex-start',
          }}
        >
          <Button disabled={templateId === undefined} onClick={onNext}>
            {t('common:next')}{' '}
            <ArrowRightIcon sx={{ marginLeft: 8 }} size={20} />
          </Button>
          <Button variant="default" onClick={close}>
            {t('common:cancel')}
          </Button>
        </Box>
      </WizardStepActions>
    </WizardStepRoot>
  );
};
